import type { FaireProductEntity } from "../../entity_types/product";

export const p_g8zmnk45us: FaireProductEntity = {
  token: "p_g8zmnk45us",
  type: "product",
  name: "White Mommy & Me Heart Print Knit Pullover Sweater",
  brandToken: "b_xvvfvktx6s",
  brandName: "Rylee Faith Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/ca2442ca4a774a0ec3a21e4ae30f04bb04b84b755ed8ff2197c813bd88f0c786.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fb6da4b294e7de47c12f949683a7e2c16b921c354895afa3a0560b8cfc170688.jpeg",
    "https://cdn.faire.com/fastly/50e10ee3a16779aa10598c33d63b225debbadc2882def494bcc5ce01d86e4d48.jpeg",
    "https://cdn.faire.com/fastly/8f9e54ad37767904e92aac6d669945b644b3c29b49880d7e3fc4a65922e793d2.jpeg",
    "https://cdn.faire.com/fastly/735d202d0e53c372d9449ed0bb01d71550b76856f5dc2bd7b6f1e8034d4a2d21.jpeg",
    "https://cdn.faire.com/fastly/32bf4d75a1ebda94ad92cf792daba1fd2814afa14d9dae77b6480b3bf0698aa3.jpeg",
    "https://cdn.faire.com/fastly/9fe458493ca9309501d2d8c4967a60bd91dfe779edad03c24dc00e7c82f02f96.jpeg",
    "https://cdn.faire.com/fastly/df22a2f28c57d066ea178c12846bc270d4bb77aee0c2d135537575862678b1b2.jpeg",
    "https://cdn.faire.com/fastly/bd0a492227628b56b04da67ff50936d5a92856a954356987f72d9a71880c299a.jpeg",
    "https://cdn.faire.com/fastly/9ccdabe74f79fd623cdf1446f38599f7eac51399f3a516f65eee15534721f7c4.jpeg",
    "https://cdn.faire.com/fastly/1cf846181d9a8ba8c8049dd0369d297b69efdcf7fb723774c4e34c566f85ef24.jpeg",
    "https://cdn.faire.com/fastly/3a79e12852bd07e382c4c33fd547691518dd855edb5cba67dedb14a3191df69a.jpeg",
    "https://cdn.faire.com/fastly/283a6d510e259065789571f177dcd2ec4b29f0f5166f8c6719124aa8eef42bf9.jpeg",
    "https://cdn.faire.com/fastly/4808002c7ed20d5603ee5c90485cb7de32bfe227336b7c4447e056039f82b6bc.jpeg",
    "https://cdn.faire.com/fastly/48e429c56fe92a0cc33b3a84a80fa4f668ace217a2690e5bd6fd601bfce1d841.jpeg",
    "https://cdn.faire.com/fastly/325c8eeefd370e5e0188193c546aaed97c997d66f736654c8f8fa3752b9c97f4.jpeg",
    "https://cdn.faire.com/fastly/c8677d41bfadcaafc9246fa82d5bfe975c40a5b3b686bb9f9ff61a46b28e4501.jpeg",
    "https://cdn.faire.com/fastly/7abf97669d05caeb363d6ea5502994a980da5fbc1bf4444464332850f3f03da6.jpeg",
  ],
  priceDollars: 23,
  description:
    "Experience the warmth of togetherness with the White Mom and Me Heart Print Knit Pullover Sweater. Its soft, cozy knit fabric in a timeless off-white shade offers comfortable wear for both mom and child. The sweet heart print highlights your special bond, making it the perfect choice for matching outfits that celebrate love and family moments. Stay stylish and connected with this charming pullover.\n\nWhite kids:TPG51351,\n\nWhite adult:TPW50607\n\nMaterial:Viscose 60%,PBT 30%,Nylon 10%\n\n\n\n\n\n\n",
  tags: [],
  msrpDollars: 46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:09.273Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
